import { IAction } from '@Root/types'

import {
  ISubtitle,
  ISubtitleReference,
} from '@SiteModules/Subtitle/types'

export const ProjectVersionActionTypes = {
  DELETE_PROJECT_VERSIONS: '@@projectVersion/DELETE_PROJECT_VERSIONS',
  DELETE_PROJECT_VERSIONS_SUCCESS: '@@projectVersion/DELETE_PROJECT_VERSIONS_SUCCESS',
  DELETE_PROJECT_VERSIONS_FAILURE: '@@projectVersion/DELETE_PROJECT_VERSIONS_FAILURE',
  UPDATE_PROJECT_VERSION_TITLE: '@@projectVersion/UPDATE_PROJECT_VERSION_TITLE',
  UPDATE_PROJECT_VERSION_TITLE_SUCCESS: '@@projectVersion/UPDATE_PROJECT_VERSION_TITLE_SUCCESS',
  UPDATE_PROJECT_VERSION_TITLE_FAILURE: '@@projectVersion/UPDATE_PROJECT_VERSION_TITLE_FAILURE',
}

export interface IProjectVersion {
  readonly id: string
  readonly attributes: IProjectVersionAttributes
  readonly subtitles: ISubtitle[]
}

export interface IProjectVersionData {
  readonly id: string
  readonly type: 'projectVersion'
  readonly attributes: IProjectVersionAttributes
  readonly relationships: IProjectVersionRelationships
}

export interface IProjectVersionAttributes {
  readonly title: string
  readonly status: string
  readonly duration: string
  readonly unformattedDuration: number
  readonly thumbnailUrl: string
  readonly language: string
  readonly createdAt: string
  readonly projectId: string
  readonly hasBeenCaptionedForFree: boolean
  readonly hasAnySubscriptionSubtitles: boolean
  readonly hasMainAssets: boolean,
  readonly isShortened: boolean,
  readonly isRepurposed: boolean
  readonly isPreparingRepurposedClips: boolean
  readonly belongsToManualProject: boolean
  readonly belongsToTtsProject: boolean
  readonly isDisabled: boolean
  readonly mostRecentUpdatedAtTimestamp: number
}

export interface IProjectVersionRelationships {
  readonly subtitles: {
    readonly data: ISubtitleReference[]
  }
}

export interface IProjectVersionReference {
  readonly id: string
  readonly type: 'projectVersion'
}

export interface IDeleteProjectVersionsPayload {
  readonly projectVersionIds: string[]
}

export type IDeleteProjectVersionsSuccessPayload = IDeleteProjectVersionsPayload

export interface IUpdateProjectVersionTitlePayload {
  projectVersionId: string
  updatedTitle: string
}

export type IUpdateProjectVersionTitleSuccessPayload = IUpdateProjectVersionTitlePayload

export type TProjectVersionActionTypes =
  IAction<IDeleteProjectVersionsSuccessPayload> |
  IAction<IUpdateProjectVersionTitleSuccessPayload>
